import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Publisher } from '../models/publisher.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import publishersQuery from 'src/app/graphql/queries/publishers.query.graphql'

@Injectable()
export class PublisherService extends GraphQLService<Publisher> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  fetchPublishers(): Observable<Publisher[]> {
    return this.findAll(publishersQuery)
  }

}
